export const ADD_WORKSPACE_FIELD_NAME = 'workspaceName';
